import styled from 'styled-components';

export const ContainerInputDestino = styled.div<{ collapsed: boolean }>`
  display: grid;
  grid-template-columns: 63% 30%;
  align-items: center;
  gap: 0.9375rem;

  @media only screen and (max-width: 1650px) {
    grid-template-columns: 60% 30%;
  }

  @media only screen and (max-width: 1500px) {
    grid-template-columns: 55% 30%;
  }

  @media only screen and (max-width: 1350px) {
    grid-template-columns: 50% 30%;
  }

  @media only screen and (max-width: 1200px) {
    grid-template-columns: 45% 25%;
  }

  @media only screen and (max-width: 1050px) {
    grid-template-columns: 40% 20%;
  }

  @media only screen and (max-width: 900px) {
    grid-template-columns: 35% 15%;
  }

  @media only screen and (max-width: 750px) {
    grid-template-columns: 30% 10%;
  }

  .input-bandeira-finalizadora {
    display: flex;
    gap: 15px;

    input {
      width: ${({ collapsed }) => (collapsed ? '15.625rem' : '10rem')};

      @media only screen and (max-width: 1200px) {
        width: ${({ collapsed }) => (collapsed ? '12.5rem' : '6.875rem')};
      }
    }
  }
`;
